var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSecureframe = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 83 87"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0FD082",
  d: "M30.8.01C13.66.76 0 14.89 0 32.22c0 7.35 2.51 14.44 7.05 20.12h12.66l-3.8-3.8a23.08 23.08 0 0 1-6.76-16.33c0-12.75 10.34-23.09 23.09-23.09h50.2V0H30.8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0FD082",
  d: "M44.75 52.34H31.81l-9.85-9.85a14.53 14.53 0 0 1-4.25-10.27c0-8.02 6.5-14.53 14.53-14.53h50.2v9.15h-50.2c-2.97 0-5.38 2.41-5.38 5.38 0 1.43.57 2.8 1.58 3.8l16.32 16.32z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#0FD082",
  d: "M51.64 86.62c17.14-.75 30.8-14.88 30.8-32.21 0-7.35-2.51-14.44-7.05-20.12H62.73l3.8 3.8c4.33 4.33 6.76 10.2 6.76 16.33 0 12.75-10.34 23.09-23.09 23.09H0v9.12h51.64z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#0FD082",
  d: "M37.68 34.29h12.94l9.85 9.85c2.72 2.72 4.25 6.42 4.25 10.27 0 8.02-6.5 14.53-14.53 14.53H0v-9.15h50.2c2.97 0 5.38-2.41 5.38-5.38 0-1.43-.57-2.8-1.58-3.8z"
})));
export default SvgSecureframe;